package br.com.vvrefeicoes.portal.navigation

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import com.composables.icons.lucide.House
import com.composables.icons.lucide.Lucide
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.app_access_denied_message
import portalvv.shared.generated.resources.app_access_denied_title
import portalvv.shared.generated.resources.app_go_home
import portalvv.shared.generated.resources.undrawable_lost_trip

/** Renderiza [content] apenas se o usuário tiver [permission]; caso contrário mostra [UnallowedState]. */
@Composable
fun RequirePermission(
    permission: String?,
    onGoHome: () -> Unit,
    content: @Composable () -> Unit,
) {
    val permissions = rememberSessionPermissions()
    if (canAccess(permissions.keys, permission)) {
        content()
    } else {
        UnallowedState(onGoHome = onGoHome)
    }
}

@Composable
fun UnallowedState(
    onGoHome: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxSize().padding(AppSpacing.space24),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space24, Alignment.CenterVertically),
    ) {
        Image(
            painter = painterResource(Res.drawable.undrawable_lost_trip),
            contentDescription = null,
            modifier =
                Modifier
                    .widthIn(max = 480.dp)
                    .fillMaxWidth(0.8f),
            contentScale = ContentScale.Fit,
        )
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.app_access_denied_title),
                style = MaterialTheme.typography.titleLarge,
                textAlign = TextAlign.Center,
            )
            Text(
                text = stringResource(Res.string.app_access_denied_message),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                textAlign = TextAlign.Center,
            )
        }
        AppButton(
            text = stringResource(Res.string.app_go_home),
            onClick = onGoHome,
            leadingIcon = Lucide.House,
        )
    }
}
